import FooterCompact from './FooterCompact.js'

export default FooterCompact
